/**
 * 房车圈路由
 */

export default [
  {
    path: '/add_feed',
    component: () => import('@/views/feed/add'),
    name: 'feed_add',
    meta: {requireAuth: true}
  },
  {
    path: '/feedCircle',
    component: () => import('@/views/circle/index'),
    name: 'feed_circle',
    meta: {keepAlive: true}
  },
  {
    path: '/feed',
    component: () => import('@/views/feed/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/feed/hotlist'),
        name: 'feed',
        meta: {keepAlive: true}
      },
      {
        path: 'home',
        component: () => import('@/views/feed/home'),
        name: 'feed_home',
        meta: {keepAlive: true}
      },
      {
        path: 'follow',
        component: () => import('@/views/feed/follow'),
        name: 'feed_follow',
        meta: {keepAlive: true}
      },
      {
        path: 'used',
        component: () => import('@/views/feed/used'),
        name: 'feed_used',
        meta: {keepAlive: true}
      },
      {
        path: 'hot',
        component: () => import('@/views/feed/hotlist'),
        name: 'feed_hot',
        meta: {keepAlive: true}
      },
      {
        path: 'topic/:t_id',
        component: () => import('@/views/feed/topic-info.vue'),
        // component: () => import('@/views/feed/topic'),
        name: 'feed_topic'
      },
      {
        path: '/topicinfo',
        component: () => import('@/views/feed/topic-info.vue'),
        name: 'feed_topicinfo'
      },
      {
        path: '/topicdetail',
        component: () => import('@/views/feed/topic-detail.vue'),
        name: 'feed_topicdetail'
      },
      {
        path: 'k/:key',
        component: () => import('@/views/feed/topic-redirect'),
        name: 'feed_topic_redirect'
      },
      {
        path: 'u/:u_id',
        component: () => import('@/views/feed/user'),
        name: 'feed_user',
        meta: {keepAlive: true}
      },
      {
        path: 'list',
        component: () => import('@/views/feed/list'),
        name: 'feed_list',
        meta: {keepAlive: true}
      },
      // {
      //   path: 'add',
      //   component: () => import('@/views/feed/add'),
      //   name: 'feed_add'
      // },
      {
        path: ':id/detail',
        component: () => import('@/views/feed/detail'),
        name: 'feed_detail'
      },
      {
        path: ':id/thumup',
        component: () => import('@/views/feed/thumb'),
        name: 'feed_thumb'
      },
      {
        path: ':id/album',
        component: () => import('@/views/feed/album'),
        name: 'feed_album'
      },
      {
        path: 'message',
        component: () => import('@/views/feed/message'),
        name: 'feed_message'
      }
    ]
  },
  {
    path: '/faq',
    component: () => import('@/views/faq/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/faq/home'),
        name: 'faq'
      },
      {
        path: 'list',
        component: () => import('@/views/faq/list'),
        name: 'faq_list'
      },
      {
        path: 'add',
        component: () => import('@/views/faq/add'),
        name: 'faq_add',
        meta: {requireAuth: true}
      },
      {
        path: ':id/detail',
        component: () => import('@/views/faq/detail'),
        name: 'faq_detail'
      },
      {
        path: ':id/album',
        component: () => import('@/views/faq/album'),
        name: 'faq_album'
      },
      {
        path: 'search',
        component: () => import('@/views/faq/search'),
        name: 'faq_search'
      }
    ]
  },
  {
    path: '/camp',
    component: () => import('@/views/camp/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/camp/home'),
        name: 'camp'
      },
      {
        path: 'search',
        component: () => import('@/views/camp/search'),
        name: 'camp_search'
      },
      {
        path: 'detail/:id',
        component: () => import('@/views/camp/detail'),
        name: 'camp_detail'
      },
      {
        path: 'recovery/:id',
        component: () => import('@/views/camp/recovery'),
        name: 'camp_recovery'
      },
      {
        path: 'comment/:id',
        component: () => import('@/views/camp/comment'),
        name: 'camp_comment'
      },
      {
        path: 'list/:id',
        component: () => import('@/views/camp/list'),
        name: 'comment_list'
      },
      {
        path: 'upimg/:id',
        component: () => import('@/views/camp/add-img'),
        name: 'add_img'
      },
      {
        path: 'info/:id',
        component: () => import('@/views/camp/comment-detail'),
        name: 'comment-info'
      },
      {
        path: 'share',
        component: () => import('@/views/camp/share'),
        name: 'camp_share'
      }
    ]
  },
  {
    path: '/browser',
    component: () => import('@/views/Common/browser'),
    name: 'browser'
  },
  {
    path: '/amap',
    component: () => import('@/views/Common/amap'),
    name: 'allAmap'
  },
  {
    path: '/topic',
    component: () => import('@/views/topic/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/topic/home'),
        name: 'topic'
      },
      {
        path: 'k/:key',
        component: () => import('@/views/topic/key'),
        name: 'topic_key'
      },
      {
        path: ':id',
        component: () => import('@/views/topic/list'),
        name: 'topic_feed'
      }
    ]
  },
  {
    path: '/ufans/:u_id',
    component: () => import('@/views/u/fans'),
    name: 'u_fans'
  },
  {
    path: '/ufollow/:u_id',
    component: () => import('@/views/u/follow'),
    name: 'u_follow'
  },
  {
    path: '/u/:u_id',
    component: () => import('@/views/u/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/u/home'),
        name: 'u_home'
      },
      {
        path: 'feed/:id',
        component: () => import('@/views/u/feed-detail'),
        name: 'u_feed_detail'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/feed.js